import React from "react";

import { LineProps } from "./utils";

export const Line: React.FC<React.PropsWithChildren<LineProps>> = ({
  start,
  end,
  ...props
}) => {
  return <line x1={start.x} y1={start.y} x2={end.x} y2={end.y} {...props} />;
};
